module.exports = __webpack_public_path__ + "img/151.7d203516.jpg";